import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator';
import { withRouter } from 'react-router-dom';
import moment from 'moment';
import { withStyles } from '@material-ui/core';
import { Info } from '@material-ui/icons';
import renderEnvComponent from 'data/common/renderEnvComponent';

class TicketHistoryEvent extends PureComponent {
    static propTypes = {
        classes: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired,
        ticketHistory: PropTypes.object.isRequired
    };

    static defaultProps = {};

    renderTicketText = () => {
        const { ticketHistory, history } = this.props;
        const time = moment(ticketHistory.createdAt, 'DD/MM/YYYY HH:mm:ss').format('HH:mm');

        if (ticketHistory.type === 'state') {
            return Translator.translate(`generic.ticketing.listing.${ticketHistory.description}`);
        }
        if (ticketHistory.type === 'creation') {
            if (ticketHistory.creator === 'undefinedCreator') {
                return `${Translator.translate(`generic.ticketing.listing.create`)} - ${Translator.translate(
                    `generic.ticketing.listing.${ticketHistory.creator}`
                )} - ${time}`;
            } else {
                return `${Translator.translate(`generic.ticketing.listing.create`)} - ${ticketHistory.creator} - ${time}`;
            }
        }
        if (ticketHistory.type === 'assignment') {
            if (ticketHistory.description === 'undefinedAssignedCraftman') {
                return `${Translator.translate(`generic.ticketing.listing.assignedTo`)} ${Translator.translate(
                    `generic.ticketing.listing.${ticketHistory.description}`
                )} - 
                ${
                    ticketHistory.creator === 'undefinedCreator'
                        ? Translator.translate(`generic.ticketing.listing.${ticketHistory.creator}`)
                        : ticketHistory.creator
                }
                 - ${time}`;
            } else {
                return `${Translator.translate(`generic.ticketing.listing.assignedTo`)} ${ticketHistory.description} - 
                ${
                    ticketHistory.creator === 'undefinedCreator'
                        ? Translator.translate(`generic.ticketing.listing.${ticketHistory.creator}`)
                        : ticketHistory.creator
                }
                 - ${time}`;
            }
        }
    };

    render() {
        const { classes } = this.props;
        const renderTicketText = this.renderTicketText();

        return (
            <div className={classes.eventTicketContainer}>
                <div className={classes.eventContainer}>
                    <span className={classes.icon}>
                        <Info />
                    </span>
                    {renderTicketText}
                </div>
            </div>
        );
    }
}

const styles = theme => ({
    eventTicketContainer: {
        width: 'auto',
        textAlign: 'center'
    },
    eventContainer: {
        display: 'inline-block',
        textAlign: 'center',
        color: theme.palette.colors.grey400
    },
    icon: {
        marginRight: 10
    }
});

export default withRouter(renderEnvComponent('components/TicketHistoryEvent', withStyles(styles, { withTheme: true })(TicketHistoryEvent)));



// WEBPACK FOOTER //
// ./environments/genericEnv/components/TicketHistoryEvent.js